import { ProductBuilderMachineContext } from '../types';
import { productPropertySummary } from './productPropertySummary';

type VenetianLineItems = (
  context: ProductBuilderMachineContext,
) => {
  _ROOM: string;
  _BLINDTYPE: string;
  _CLEAT: string;
  _CLOTHTAPECOLORID: string;
  _HDBRACKET: string;
  _HEADRAILMAT: string;
  _LADDERTYPE: string;
  _MOUNTTYPE: string;
  _MATCHITEM: string;
  _PGMCODE: string;
  _PULLCORDPOS1: string;
  _PUNCHTYPE: string;
  _PULLCORDLENGTH: string;
  _REMARK: string;
  _SIZETYPE: string;
  _SLATSIZE: string;
  _STASSELTYPE: string;
  _TASSELDESIGN: string;
  _TILTCORDPOS1: string;
  _TILTTYPE: string;
  _TILTCORDLENGTH: string;
  _VALANCETYPE: string;
  _VALRETURN: string;
  _VALLENGTH: string;
  _VALRTNPOS: string;
  _WALLANCHOR: string;
  _WIDTH1: string;
  _WIDTH2: string;
  _dynamic_product: boolean;
  _HEADRAILCOLOR: string;
  _CONTROLTYPE: string;
  _LADDERCORDCOLORID: string;
  _COLORCODE: string;
};

export const getVenetianLineItems: VenetianLineItems = context => {
  const { custom } = context;
  const productSummaryCapture = productPropertySummary(context);
  const venetianType = context.products[0].type.replace('Venetian ', '');

  const currentVariant = context.productWithMeasurements
    ? context.productWithMeasurements.data.find(
        ({ attributes: { freight } }) => freight === context.custom.shipping,
      )
    : null;

  const baseProduct = context.products.filter(product =>
    product.variants.some(
      variant =>
        variant.id ===
        (currentVariant ? currentVariant.attributes.base_variant_id : null),
    ),
  );

  const controlType =
    baseProduct && baseProduct[0].type === 'Venetian PVC Cordless'
      ? 'Ultimate CordLess'
      : baseProduct && baseProduct[0].type === 'Venetian PVC Corded'
      ? 'Corded'
      : baseProduct && baseProduct[0].type === 'Venetian Timber Cordless'
      ? 'Ultimate CordLess'
      : baseProduct && baseProduct[0].type === 'Venetian Timber Corded'
      ? 'Corded'
      : baseProduct && baseProduct[0].type === 'Venetian Aluminium'
      ? 'Corded'
      : '';

  const colourCode = baseProduct
    ? baseProduct[0].tags
        .find(tag => tag.includes('Colour Code'))
        ?.replace('Colour Code: ', '')
    : '';

  let pgmCode, tasselDesign, tiltType, slatSize, tiltPosition, liftPosition;

  switch (true) {
    case baseProduct && baseProduct[0].type === 'Venetian Timber Cordless':
      pgmCode = 'PN';
      tiltType = 'Wand';
      tasselDesign = '';
      slatSize = context.custom.slatSize === '50mm' ? 'SL01' : 'SL02';
      break;
    case baseProduct && baseProduct[0].type === 'Venetian Timber Corded':
      pgmCode = 'PN';
      tiltType = 'Cord';
      tasselDesign = 'WTP';
      slatSize = context.custom.slatSize === '50mm' ? 'SL01' : 'SL02';
      break;
    case baseProduct && baseProduct[0].type === 'Venetian PVC Cordless':
      pgmCode = 'FW';
      tiltType = 'Wand';
      tasselDesign = '';
      slatSize = context.custom.slatSize === '50mm' ? 'SL06' : 'SL02';
      break;
    case baseProduct && baseProduct[0].type === 'Venetian PVC Corded':
      pgmCode = 'FW';
      tiltType = 'Cord';
      tasselDesign = 'MCB';
      slatSize = context.custom.slatSize === '50mm' ? 'SL06' : 'SL02';
      break;
    default:
      pgmCode = 'AL';
      tiltType = context.custom.tiltControl;
      tasselDesign = '';
      slatSize = 'SL05';
  }

  tiltPosition = custom.tiltPosition === 'Left' ? 'L' : 'R';
  liftPosition = custom.liftPosition === 'Left' ? 'L' : 'R';

  return {
    _ROOM: context.custom.roomName,
    _BLINDTYPE: 'SINGLE',
    // _CLEAT: controlType === 'Corded' ? 'Y' : '', OLD value(date: 06-10-2023)
    _CLEAT: controlType === 'Corded' ? 'Y' : venetianType === 'Aluminium' ? 'Y' : '',
    _CLOTHTAPECOLORID: '', // always empty
    _HDBRACKET: 'Y',
    _HEADRAILMAT: venetianType == 'PVC Cordless' ||  venetianType == 'PVC Corded' ? 'Deco' : 'PVC', // Update value(date: 13-10-2023 in venetianType Aluminium add PVC) (22-8-2025) update new type Deco for fauxwood pvc coreded and cordless and PVC type or remaining all 
    _LADDERTYPE: 'LC',
    _MOUNTTYPE: context.custom.fitting === 'Reveal Fit' ? 'IN' : 'OUT',
    _MATCHITEM: '', // Veneta only
    _PGMCODE: pgmCode,
    _PULLCORDPOS1: controlType === 'Corded' ? liftPosition : '',
    _PUNCHTYPE: venetianType === 'Aluminium' ? 'Center' : 'Privacy',
    _PULLCORDLENGTH: '', // Veneta only
    _REMARK: '', // empty
    _SIZETYPE: context.custom.fitting === 'Reveal Fit' ? 'WS' : 'MFF',
    _SLATSIZE: slatSize,
    _STASSELTYPE: controlType === 'Corded' ? 'ST01' : '',
    _TASSELDESIGN: tasselDesign,
    _TILTCORDPOS1: tiltPosition,
    _TILTTYPE: tiltType,
    _TILTCORDLENGTH: '', // Veneta only
    _VALANCETYPE:
      typeof custom.venetianValance !== 'undefined' &&
      typeof custom.venetianValance === 'number'
        ? 'RV'
        : '',
    _VALRETURN:
      custom.fitting === 'Reveal Fit' || venetianType === 'Aluminium'
        ? ''
        : typeof custom.venetianValance !== 'undefined' &&
          typeof custom.venetianValance === 'number' &&
          custom.fitting !== 'Reveal Fit' &&
          venetianType !== 'Aluminium'
        ? 'Standard'
        : '',
    _VALLENGTH: '', // Veneta only
    _VALRTNPOS:
      typeof custom.venetianValance !== 'undefined' &&
      typeof custom.venetianValance === 'number' &&
      custom.fitting !== 'Reveal Fit'
        ? 'Left&Right'
        : '',
    _WALLANCHOR: 'N',
    _WIDTH1: '',
    _WIDTH2: '',
    _dynamic_product: true,
    _HEADRAILCOLOR: 'TD01',
    _CONTROLTYPE: controlType,
    _LADDERCORDCOLORID: 'TD01',
    _COLORCODE: colourCode ? colourCode : '',
    ...productSummaryCapture,
  };
};
